module.exports = __webpack_public_path__ + "front/img/b26_2.92324058.jpg";